import React from 'react';

import {
  TextField,
  DatePicker,
  TextAreaField,
  Select,
  NumberField,
  Checkbox,
  Upload,
  RadioGroup,
  FormattedNumberField,
  NumberFieldWithDecimals,
} from 'components';

const FormField = ({ type, field, ...rest }) => {
  const renderField = () => {
    switch (type) {
      case 'text':
        return <TextField {...rest} />;
      case 'string':
        return <TextField {...rest} />;
      case 'null':
        return <TextField {...rest} />;
      case 'number':
        return <NumberField {...rest} />;
      case 'date':
        return <DatePicker {...rest} />;
      case 'textarea':
        return <TextAreaField {...rest} />;
      case 'select':
        return <Select {...rest} />;
      case 'checkbox':
        return <Checkbox {...rest} />;
      case 'upload':
        return <Upload {...rest} />;
      case 'boolean':
        return <RadioGroup {...rest} />;
      case 'radio':
        return <RadioGroup {...rest} />;
      case 'formattedNumber':
        return <FormattedNumberField {...rest}/>;
      case 'numberWithDecimals':
        return <NumberFieldWithDecimals {...rest}/>;
      default:
        return <TextField {...rest} />;
    }
  };
  return <div>{renderField()}</div>;
};

export default FormField;
